export default "__VITE_ASSET__BaqzTTPi__"